<template>
  <div id="app" v-click-outside="ignoreClickOutside" data-app>
    <div class="d-contents" :class="{ 'only-mobile-hide': !isPublicTenderPage }">
      <div v-if="hasToken && isLoading" class="page-loader">
        <Spinner size="96" />
      </div>
      <router-view v-else />
      <AlertTooltipsContainer />
      <Modal />
      <Confirm />
      <ContextMenu />
      <Error />
    </div>
    <MobilePlug
      :class="{
        'only-mobile-show': !isPublicTenderPage,
        'd-none': isPublicTenderPage,
      }"
    />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Spinner from 'vue-simple-spinner';
  import ContextMenu from '@/components/ui/ContextMenu';
  import Error from '@/components/ui/Error';
  import Modal from '@/components/ui/Modal';
  import ClickOutside from 'vue-click-outside';
  import openModal from '@/utils/mixins/open-modal';
  import Confirm from '@/components/ui/Confirm';
  import { intercomInit, isTrackersEnabled } from '@/integrations';
  import MobilePlug from '@/components/ui/MobilePlug';
  import AlertTooltipsContainer from '@/components/ui/alert-tooltip/AlertTooltipsContainer';

  export default {
    components: {
      AlertTooltipsContainer,
      MobilePlug,
      Error,
      ContextMenu,
      Spinner,
      Modal,
      Confirm,
    },
    directives: { ClickOutside },
    mixins: [openModal],
    data() {
      return {
        // В корне на хуках не получается отследить
        // route name, записываем его через watch
        routeName: '',
      };
    },
    computed: {
      ...mapState({
        isLoading: (state) => state.auth.isLoading,
        hasToken: (state) => state.auth.token !== null,
        user: (state) => state.auth.user,
        isModalOpen: (state) => state.modal.open,
      }),
      isPublicTenderPage() {
        return this.routeName === 'public-tender';
      },
    },
    async created() {
      const publ = window.location.pathname.match(/\/public\/([^/]+)/);
      if (publ?.[1]) this.setPublicAccess(publ[1]);

      const match = window.location.href.match(
        /\?from_landing=(true)&project_id=(\w+)&token=(\w+)/i
      );
      if (match) await this.authLoad({ token: match?.[3], toProject: match?.[2] });
      else await this.authLoad();
      await this.fetchProperties();
      this.$i18n.locale = this.user?.language || localStorage.locale || 'en';
      localStorage.setItem('locale', this.user?.language || localStorage.locale || 'en');
      if (isTrackersEnabled()) {
        intercomInit(this.user);
      }
    },
    methods: {
      ...mapActions({
        authLoad: 'auth/load',
        setPublicAccess: 'auth/setPublicAccess',
        fetchProperties: 'global/fetchProperties',
      }),
      ignoreClickOutside(event) {
        event.stopImmediatePropagation();
      },
    },
    watch: {
      '$route.name': function (name) {
        this.routeName = name;
      },
      isModalOpen(value) {
        if (value) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      },
    },
  };
</script>
